import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, User, LogOut, Search, Menu } from "lucide-react";
import { useApp } from "../store";

export default function Navbar() {
  const { user, cart, setAuthOpen, logout, settings } = useApp();
  const navigate = useNavigate();
  const cartCount = cart.reduce((s, c) => s + c.quantity, 0);
  const s = settings || {};

  return (
    <nav className="nav-glass fixed top-0 inset-x-0 z-50" data-testid="main-nav">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <Link to="/" className="flex flex-col leading-none" data-testid="brand-link">
          <span className="font-serif-display text-2xl tracking-tight">{s.brand_name_top || "World of"}</span>
          <span className="overline text-[10px] text-copper -mt-0.5">{s.brand_name_bottom || "Floral Absolutes"}</span>
        </Link>

        <div className="hidden md:flex items-center gap-10 overline text-[11px]">
          <Link to="/catalog" data-testid="nav-catalog" className="hover:text-copper transition-colors">Catalog</Link>
          <Link to="/catalog?category=Floral%20%26%20Absolute" data-testid="nav-florals" className="hover:text-copper">Florals</Link>
          <Link to="/catalog?category=Attar" data-testid="nav-attars" className="hover:text-copper">Attars</Link>
          <Link to="/catalog?category=Wood%20%26%20Resin" data-testid="nav-woods" className="hover:text-copper">Wood &amp; Resin</Link>
          <Link to="/catalog?category=Resinoid" data-testid="nav-resinoids" className="hover:text-copper">Resinoids</Link>
          <Link to="/blog" data-testid="nav-blog" className="hover:text-copper">Journal</Link>
          <Link to="/inquiry" data-testid="nav-inquiry" className="hover:text-copper">B2B Inquiry</Link>
        </div>

        <div className="flex items-center gap-5">
          <button onClick={() => navigate("/catalog")} aria-label="Search" data-testid="nav-search">
            <Search size={18} strokeWidth={1.5} />
          </button>
          {user ? (
            <div className="relative group">
              <button className="flex items-center gap-2" data-testid="nav-user">
                <User size={18} strokeWidth={1.5} />
                <span className="hidden md:inline text-xs">{user.name?.split(" ")[0]}</span>
              </button>
              <div className="absolute right-0 top-full mt-3 bg-white border border-[#E5E1D8] py-2 w-44 invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-all duration-200 z-10">
                {user.role === "admin" && (
                  <Link to="/admin" className="block px-4 py-2 text-xs hover:bg-[#F3EFE9]" data-testid="nav-admin-link">Admin Dashboard</Link>
                )}
                <Link to="/orders" className="block px-4 py-2 text-xs hover:bg-[#F3EFE9]" data-testid="nav-my-orders">My Orders</Link>
                <Link to="/addresses" className="block px-4 py-2 text-xs hover:bg-[#F3EFE9]" data-testid="nav-addresses">Address Book</Link>
                <button onClick={logout} className="w-full text-left px-4 py-2 text-xs hover:bg-[#F3EFE9] flex items-center gap-2" data-testid="nav-logout">
                  <LogOut size={14} /> Sign out
                </button>
              </div>
            </div>
          ) : (
            <button onClick={() => setAuthOpen(true)} className="overline text-[11px] hover:text-copper" data-testid="nav-login">Sign in</button>
          )}
          <Link to="/cart" className="relative" data-testid="nav-cart">
            <ShoppingBag size={18} strokeWidth={1.5} />
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-copper text-[#FAF9F6] text-[10px] w-4 h-4 flex items-center justify-center rounded-full">
                {cartCount}
              </span>
            )}
          </Link>
        </div>
      </div>
    </nav>
  );
}
